import * as React from "react";
import { singleton } from "logic/singleton";
const PerspectivesContext = React.createContext(void 0);
export default singleton("contexts.PerspectivesContext", () => PerspectivesContext);
